/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSS} from '../../../assets/ts/_utils'
import {InsuranceType} from '../../../../app/modules/insurance/healthInsurance/apis/formAPIs/formAPIs'
import {formatter, useLocalStorage} from '../../../../app/utils'
import moment from 'moment'
import {ChartRenewModel} from '../../../../app/pages/dashboard/components/SummaryHealthInsurances'

type Props = {
  className: string
  dataChart: ChartRenewModel
}

const PieChart: React.FC<Props> = ({className, dataChart}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (dataChart.dataType.length == 0) return

    if (!chartRef.current) {
      return
    }
    const height = 300
    const chart = new ApexCharts(
      chartRef.current,
      getChartOptions(height, dataChart.dataType, dataChart.dataContract)
    )
    if (chart) {
      //chart.updateSeries(dataPieFormater);
      chart.render()
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [dataChart])

  return (
    <div>
      <div ref={chartRef} id='kt_charts_widget_1_chart' style={{height: '150px'}} />
    </div>
  )
}

export {PieChart}

function getChartOptions(height: number, label: any, dataPie: any): ApexOptions {
  return {
    chart: {
      type: 'pie',
      height: '250px',
      toolbar: {
        show: false,
      },
    },
    series: dataPie,
    labels: label,
    colors: ['#0096A9', '#D2D711', '#ff0000','#1f8ce9'],
    yaxis: {
      labels: {
        formatter: function (value) {
          return isNaN(value) ? value.toString() : formatter(value)
        },
      },
    },
    // responsive: [
    //   {
    //     breakpoint: 480,
    //     options: {
    //       chart: {
    //         width: 200,
    //       },
    //       legend: {
    //         position: 'bottom',
    //       },
    //     },
    //   },
    // ],
  }
}
